import ListLayout from "../../../components/layout/main/ListLayout";
import { PageCard } from "../../../styles/CommonStyles";
import FilterLayout from "../../../components/layout/filter/FilterLayout";
import { useState } from "react";
import { CacheKeys, rewardsOptions } from "../../../core/constants/filter";
import { useWindowSize } from "../../../core/hooks/common/useWindowSize";
import { TABLET_SIZE } from "../../../core/constants/common";
import RewardsListTable from "../../../components/main/reports/reward/RewardsTable";
import RRewardListTable from "../../../components/responsive/main/reports/reward/RRewardsListTable";
import { useGetAllReward } from "../../../core/services/react-query/report/reward";


const RewardsList = () => {

    const { width } = useWindowSize()
    const [rewards, setRewards] = useState({ data: null, loading: true })


    const onQuerySuccess = (res) => {
        setRewards(res)
    }

    const Component = width > TABLET_SIZE ? RewardsListTable : RRewardListTable

    return (
        <ListLayout>
            <PageCard>
                <FilterLayout
                    hasFilter={false}
                    options={rewardsOptions}
                    query={useGetAllReward}
                    onQuerySuccess={onQuerySuccess}
                    cache={CacheKeys.REWARD}
                >
                    {width && 
                        <Component
                            data={rewards}
                        />
                    }
                </FilterLayout>
            </PageCard>
        </ListLayout>
    )
}

export default RewardsList;
